import Api from "@/repository/api";
import {ResponseDataType} from "@/form/form.types";
import { ICashboxSettings, ICashboxSettingsListItem, CashboxSettingsResponseType } from '@/entity/finance/cashbox/cashboxSettings.types';
import { ISettingsCashBoxRepository } from "./SettingsCashBoxRepository.types";
import CashboxSettings from "@/entity/finance/cashbox/cashboxSettings";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import qs from "qs";
import { PaymentSettingsRequestType } from '@/form/Settings/finances/pyment.type';

export class SettingsCashBoxRepository implements ISettingsCashBoxRepository {
    async fetchAll(data?: FormData): Promise<ICashboxSettings> {
        const response = await Api.get('/finance/cashbox/settings/get', { 
            params: data, 
            paramsSerializer: function paramsSerializer(params) {
            return new URLSearchParams(params).toString()
            }});
        const responseData = response.data as CashboxSettingsResponseType;
        return new CashboxSettings(responseData);
    }

    async fetchData(data: PaginationRequestType): Promise<ICashboxSettingsListItem> {

        const response = await Api.get(`/finance/cashbox/settings/get`, {
            params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});

        const responseData = response.data as CashboxSettingsResponseType;

        return new CashboxSettings(responseData).data[0];
    }

    async create(data: PaymentSettingsRequestType): Promise<ResponseDataType> {
        const response = await Api.post('/finance/cashbox/settings/create', data);
        return response.data;
    }

    async update(data: PaymentSettingsRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/finance/cashbox/settings/update`, data);
        const responseData = response.data;
        return responseData;
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const response = await Api.post(`/finance/cashbox/settings/delete`, data);
        const responseData = response.data;
        return responseData;
    }

}